import React, { useEffect, useState } from 'react'

import Megafono from "assets/icons/megafono.png"
import Switch from 'react-bootstrap/esm/Switch'
import { ReactComponent as IconoMegafonoNaranja } from 'assets/icons/ParaSUconocimiento.svg';
import { ReactComponent as Advertencia } from 'assets/icons/ADVERTENCIA.svg';
import { ReactComponent as AdvertenciaTriangulo } from 'assets/icons/warningtriangle.svg';

import { Button } from "reactstrap";

import { ReactElement } from "react";


{/* <div>Iconos diseñados por <a href="https://www.freepik.com" title="Freepik">Freepik</a> from <a href="https://www.flaticon.es/" title="Flaticon">www.flaticon.es</a></div> */ }

export enum TiposAlerta {
    MENSAJE_ALMUERZO = 1,
    ADVERTENCIA = 5,
    PARA_CONOCIMIENTO = 6
}


export type PropsAlertNew = {
    mensaje?: string,
    oncloseElement?: () => void,
    mensajeHTML?: any,
    closeButton?: boolean,
    tipo?: TiposAlerta,
    cabeceraTitulo?: string,
    iconoAlerta?: any,
    classNameAdicional?: string
    actionButton?: boolean,
    onActionElement?: () => void,
}

const AlertNewAction = (props: PropsAlertNew) => {


    const [idIconoAlerta, setidIconoAlerta] = useState<string>("");
    const [classNameAlerta, setclassNameAlerta] = useState<string>("");




    useEffect(() => {

        var timer = setInterval(() => {
            if (props.tipo == TiposAlerta.ADVERTENCIA) {
                setidIconoAlerta(prevIcono =>
                    prevIcono === "iconoAdvertenciaTrianguloEncendido" || prevIcono === ""
                        ? "iconoAdvertenciaTriangulo"
                        : "iconoAdvertenciaTrianguloEncendido"
                );

                setclassNameAlerta(prevClassName =>
                    prevClassName === "new-alert-advertencia-triangulo-enc" || prevClassName === ""
                        ? "new-alert-advertencia-triangulo"
                        : "new-alert-advertencia-triangulo-enc"
                );
            } else if (props.tipo == TiposAlerta.MENSAJE_ALMUERZO) {
                setidIconoAlerta(prevIcono =>
                    prevIcono === "iconoAdvertenciaTrianguloEncendido" || prevIcono === ""
                        ? "iconoAdvertenciaTriangulo"
                        : "iconoAdvertenciaTrianguloEncendido"
                );

                setclassNameAlerta(prevClassName =>
                    prevClassName === "new-alert-almuerzo-triangulo-enc" || prevClassName === ""
                        ? "new-alert-almuerzo-triangulo"
                        : "new-alert-almuerzo-triangulo-enc"
                );
            }
        }, 500);
        return () => clearInterval(timer);
    }, [])




    var classNameTipoAlerta = ""
    var classNameCuerpoAlerta = "cuerpo_alerta"
    var iconoAlerta: React.ReactElement | undefined = undefined;
    var mostrarCabecera = true;

    if (props.tipo !== undefined) {
        switch (props.tipo) {
            case TiposAlerta.MENSAJE_ALMUERZO:
                classNameTipoAlerta = classNameAlerta === "" ? "new-alert-almuerzo-triangulo" : classNameAlerta
                //classNameTipoAlerta = "new-alert-almuerzo-triangulo"
                const idIconoAlmuerzo = idIconoAlerta === "" ? "iconoAdvertenciaTriangulo" :idIconoAlerta
                iconoAlerta = <AdvertenciaTriangulo id={idIconoAlmuerzo} />
                break;
            case TiposAlerta.PARA_CONOCIMIENTO:
                classNameTipoAlerta = "new-alert-conocimiento"
                iconoAlerta = <Advertencia id="iconoAdvertenciaMensaje" style={{ "fill": "none" }} />
                break;
            case TiposAlerta.ADVERTENCIA:
                classNameTipoAlerta = classNameAlerta === "" ? "new-alert-advertencia-triangulo" : classNameAlerta
                const idIcono = idIconoAlerta === "" ? "iconoAdvertenciaTriangulo" :idIconoAlerta

                iconoAlerta = <AdvertenciaTriangulo id={idIcono} />
                classNameCuerpoAlerta = 'cuerpo-alert-advertencia-triangulo'
                break;
            default:
                iconoAlerta = <img src={Megafono} className="icono_imagen " />
                break;
        }
    }


    const { oncloseElement, onActionElement } = props;
    return (
        <div className={`new-alert-warn mb-1 ${classNameTipoAlerta} ${props.classNameAdicional ?? ""}`}>

            {
                props.closeButton === undefined || (props.closeButton !== undefined && props.closeButton === true) && oncloseElement !== undefined && (
                    <a className="newCloseAlert" onClick={() => oncloseElement()}>&times;</a>
                )
            }




            {
                mostrarCabecera &&
                <div className={`cabecera_alerta`}>
                    {iconoAlerta}
                    {props.cabeceraTitulo ?? ""}
                </div>
            }

            {
                props.mensaje && props.mensajeHTML === undefined && (
                    <div className={classNameCuerpoAlerta}> {props.mensaje} </div>
                )
            }
            {
                props.mensajeHTML !== undefined && (
                    <div className={classNameCuerpoAlerta}>
                        {props.mensajeHTML}
                        {
                            props.actionButton === undefined || (props.actionButton !== undefined && props.actionButton === true) && onActionElement !== undefined && (
                                <Button className="button-permiso" onClick={() => onActionElement()} > CORREGIR </Button>
                            )
                        }
                    </div>
                )
            }

            



        </div>
    )
}

export default AlertNewAction;
